module.exports = __webpack_public_path__ + "img/19.2c0ee668.png";